import type { ReactNode } from 'react';
import React from 'react';

import {
  WizardCardChildrenWrapper,
  WizardCardTitle,
  VerticalWizardCardContainer,
  WizardCardHeaderActions,
  WizardCardHeader,
} from './styled';

export * from './styled';

type VerticalWizardCardProps = {
  children?: React.ReactNode;
  childrenWidth?: string;
  className?: string;
  headerActions?: ReactNode;
  padding?: number;
  title: string;
  titleSize?: number;
};

export function VerticalWizardCard({
  children,
  childrenWidth,
  className,
  padding,
  title,
  titleSize,
  headerActions,
}: VerticalWizardCardProps) {
  return (
    <VerticalWizardCardContainer $padding={padding} className={className}>
      <WizardCardHeader>
        <WizardCardTitle $titleSize={titleSize}>{title}</WizardCardTitle>
        {headerActions && <WizardCardHeaderActions>{headerActions}</WizardCardHeaderActions>}
      </WizardCardHeader>
      {children && <WizardCardChildrenWrapper $width={childrenWidth}>{children}</WizardCardChildrenWrapper>}
    </VerticalWizardCardContainer>
  );
}
